var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98389 7.50576V14.2458C1.98989 15.7698 3.34489 16.9958 4.99789 16.9908H15.6909C15.9939 16.9908 16.2399 16.7658 16.2399 16.4928V9.75276C16.2319 8.22976 14.8769 7.00276 13.2259 7.00876H2.53089C2.22889 7.00876 1.98389 7.23276 1.98389 7.50576ZM16.9199 10.1358L21.3359 7.17276C21.7189 6.88076 22.0159 6.95376 22.0159 7.48176V16.5178C22.0159 17.1188 21.6529 17.0458 21.3359 16.8268L16.9199 13.8698V10.1358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomWhite);
export default __webpack_public_path__ + "static/media/zoom-white.7b1c21b77eaf4e47bc584631a0a528be.svg";
export { ForwardRef as ReactComponent };